(ns dashboard.entity.question.question-status
  "The principle contract of the dashboard.entity component namespaces are this:
   1. All components will NOT depend on keyword references to subs and events in
      external NSes, but rather receive data as arguments, functions and callbacks.
   2. All internal reliance on the re-frame app DB must be internally contained.
   3. All re-frame app subs and events must NOT be directly referenced by outside
      NSes, but rather via GETTER and SETTER functions - the same is true of internal
      calls - prefer using parameterized functions.
   4. The entity is a UI component that may encapsulate low-level business rules on
      UI controls, but is not responsible for hydrating components with data or entrenched
      references to component namespaces. The UI is customizable, and top-level entities
      should have configurable and interchangable UI elements.")

(defn status->text [status]
  (case status
    "approved" "Approved"
    "in-review" "In Review"
    "Unknown"))

(defn status-button
  "Question Status Component

   Accepts a map with keys:
   - status
   - current-status
   - on-click
   - large?
   - selected-answer
   - disabled"
  [{:keys [status current-status on-click large? selected-answer disabled]}]
  (let [selected? (= status current-status)
        icon-class (case status
                     "approved" "fa-check-circle"
                     "in-review" "fa-question-circle"
                     #_:else "fa-times-circle")
        color-class (case status
                      "approved" "has-text-success"
                      "in-review" "has-text-warning"
                      #_:else "has-text-danger")
        color-class (if (and selected? selected-answer)
                      color-class
                      "has-text-grey-lighter")]
    [:button.px-0.is-inverted
     {:style {:border "none"
              :font-size "16px"
              :background "none"
              :cursor (cond
                        (not selected-answer) "not-allowed"
                        (not selected?) "pointer")}
      :class (when large?
               "ml-2")
      :disabled (or disabled
                    (or selected?
                        (not selected-answer)))
      :on-click on-click
      :title (str (when-not selected-answer
                    "Please select an answer before setting the question status\n\n")
                  (str "Current question status: "
                       (status->text current-status))
                  (when (and selected-answer (not  selected?))
                    (str "\n\n"
                         "Click to change question status to "
                         (status->text status))))}
     [:span.icon
      {:class (when large?
                "is-medium")}
      [:i.fas {:class (cond-> [icon-class color-class]
                        large? (conj "fa-2x")
                        (not large?) (conj "fa-lg"))}]]]))
